<template>
  <!-- 区体管部门 -->
  <yioks-content @back="handleBack">
    <template v-slot:nav_left>
      <div class="nav-btn-box" v-if="isInClubSystem">待评估机构列表</div>
      <div class="nav-btn-box" v-else>待初审机构列表</div>
    </template>

    <template v-slot:nav_right>
      <template v-if="!isInClubSystem">
        <div v-if="canEdit" class="yioks_btn" @click="handleEditSort">
          点击编辑申报初审排名
        </div>
      </template>
    </template>

    <template v-slot:content_right>
      <div class="base-content-wrapper">
        <div class="content-inner-wrapper">
          <div class="select_wrap">
            <div class="select_box left">
              <template v-if="!isInClubSystem">
                <select
                  v-model="filterData.stageApplyType"
                  class="yioks_select"
                  @change="changeQuery(true)"
                >
                  <option :value="defaultSelectStringForSearch">
                    全部申报类型
                  </option>
                  <!-- stageSelectList -->
                  <option
                    v-for="item in stageTypeListForYouthSearch"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </template>
            </div>
            <div class="select_box right">
              <input
                v-model.trim="filterData.key"
                type="text"
                class="yioks_input"
                style="width: 160px"
                placeholder="请输入关键字"
                @keyup.enter="changeQuery(true)"
              />
              <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
            </div>
          </div>

          <div class="list_wrap" v-if="!loading && !empty">
            <div class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th seq">序号</div>
                  <div class="th youthName">
                    <div>申报单位</div>
                    <div v-if="!isInClubSystem">
                      (<span class="suc"
                        >加<i class="el-icon-star-on"></i>推荐区级青训中心</span
                      >)
                    </div>
                  </div>
                  <div class="th score">申报类型</div>
<!--                  <div class="th updateTime">提交时间</div>-->
                  <template v-if="!isInClubSystem">
                    <div class="th auditSort">初审排名</div>
                  </template>

                  <div class="th orgAuditState">初审结果</div>
<!--                  <template v-if="isInClubSystem">-->
<!--                    <div class="th youthScore">自评得分</div>-->
<!--                  </template>-->
                  <template v-if="isInClubSystem">
                    <div class="th expertAuditScore">专家评分</div>
                  </template>
                  <div class="th auditScore">市体育局/足协终审结果</div>
                  <div class="th action">操作</div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll>
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        class="tr"
                        v-for="(item, index) in pageList"
                        :key="index"
                      >
                        <div class="td seq">
                          <p>{{ index + 1 }}</p>
                        </div>
                        <div class="td youthName">
                          <p>
                            {{ item.youthShortName }}
                            <template v-if="!isInClubSystem">
                              <span
                                v-if="item.recommend"
                                class="suc"
                                title="推荐"
                                >(<i class="el-icon-star-on"></i>)</span
                              >
                            </template>
                          </p>
                        </div>
                        <div class="td score">
                          <p :title="item.stageApplyType">{{ item.stageApplyType | empty }}</p>
                        </div>
                        <!-- <div class="td submit">
                          <p>{{ item.submit ? "已提交" : "未提交" }}</p>
                        </div> -->
<!--                        <div class="td updateTime">-->
<!--                          <p v-if="item.submitCreatedAt">-->
<!--                            {{ item.submitCreatedAt | time(false) }}-->
<!--                          </p>-->
<!--                          <p v-else>&#45;&#45;</p>-->
<!--                        </div>-->

                        <template v-if="!isInClubSystem">
                          <div class="td auditSort">
                            <p v-if="item.sort">
                              第&nbsp;{{ item.sort }}&nbsp;名
                            </p>
                            <p v-else>未排名</p>
                          </div>
                        </template>

                        <div class="td orgAuditState">
                          <p>
                            {{ item.auditState | auditStateFilters }}
                          </p>
                        </div>
<!--                        <template v-if="isInClubSystem">-->
<!--                          <div class="td youthScore">-->
<!--                            <p>{{ item.youthScore }}分</p>-->
<!--                          </div>-->
<!--                        </template>-->
                        <template v-if="isInClubSystem">
                          <div class="td expertAuditScore">
                            <p v-if="item.expertAudit">
                              {{ item.expertAuditScore }}分
                            </p>
                            <p v-else>--</p>
                          </div>
                        </template>
                        <div class="td auditScore">
                          <p>{{ item.adminAuditState | auditStateFilters }}</p>
                        </div>
                        <div class="td action">
                          <p v-if="canEdit">
                            <template v-if="item.submit">
                              <template v-if="!item.audit">
                                <span
                                  class="item active"
                                  @click="handleListAction('audit', item)"
                                >
                                  评估材料
                                </span>
                              </template>
                              <template v-else>
                                <span
                                  class="item active"
                                  @click="handleListAction('find', item)"
                                  >查看</span
                                >
                              </template>
                              <!-- <template v-if="item.submit && item.audit">
                                <span v-if="item.recommendShow && item.recommendUuid"  class="item active ml10" @click="handleToggleRecommend(item)">取消加星</span>
                                <span v-else-if="!item.recommendShow" class="item active ml10" @click="handleToggleRecommend(item)">加星</span>
                              </template> -->
                            </template>
                            <template v-else>
                              <span
                                class="item danger"
                                @click="handleListAction('unSubmit', item)"
                              >
                                未提交
                              </span>
                            </template>
                          </p>
                          <p v-else>
                            <span
                              class="item active"
                              @click="handleListAction('find', item)"
                            >
                              评估材料</span
                            >
                          </p>
                          <span class="item active" @click="goInfoExpert(item.uuid)"><span class="item">/</span>机构数据</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>

          <yioks-loading v-if="loading"></yioks-loading>
          <yioks-empty v-else-if="empty"></yioks-empty>

          <template v-if="isShowSortDialog">
            <sort-dialog
              :isShow.sync="isShowSortDialog"
              :groupUuid="groupUuid"
              :stageUuid="stageUuid"
              :propsType="propsType"
              :isShowStarAction="!isInClubSystem"
              @callback="handleCallback"
              @updatePageList="handleUpdatePageList"
            ></sort-dialog>
            <!-- :infoList="pageList" -->
          </template>
        </div>
      </div>

      <yioks-pagination :page.sync="page" :total="total"></yioks-pagination>
    </template>
  </yioks-content>
</template>

<script>
import {
  getAuditYouthPage,
  getAuditOrgPage,
  getOrgAuditPage,
  toggleOrgRecommend,
} from "@/api/performance";
import { stageTypeList } from "@/assets/js/yioksSelect";
import { auditStateFilters } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";
const defaultSelectString = "";
export default {
  mixins: [mixinAppConfig],
  components: {
    "sort-dialog": () => import("@/views/performance/components/SortDialog"),
  },
  data() {
    return {
      // defaultSelectString,
      pageList: [],
      // activeNav: "club",
      page: 0,
      pageSize: 20,
      total: 0,
      loading: false,
      empty: false,
      filterData: {
        key: "",
        // stageApplyType: 'defaultSelectString',
        stageApplyType: "",
      },
      isShowSortDialog: false,
    };
  },

  computed: {
    groupUuid() {
      const { groupUuid } = this.$route.query;
      return groupUuid || null;
    },

    stageUuid() {
      const { stageUuid } = this.$route.query;
      return stageUuid || null;
    },

    activeNav() {
      const { activeNav } = this.$route.query;
      return activeNav || null;
    },

    canEdit() {
      const { canEdit } = this.$route.query;
      return canEdit == "1" ? true : false;
    },

    // 推荐单位只能存在一个
    isRecommendExit() {
      const res = this.pageList.some((item) => {
        return item && item.recommend;
      });
      return res;
    },

    propsType() {
      return this.activeNav ? this.activeNav.toUpperCase() : "YOUTH";
    },

    // 基本申报类型
    // stageSelectList() {
    //   return stageTypeList.slice(0,2)
    // },
  },

  filters: {
    empty(val) {
      if (val !== undefined) {
        return val;
      } else {
        return "--";
      }
    },
    auditStateFilters,
    expertAuditScoreFilter(val) {
      if(val >= 900) {
        return '五星'
      } else if(val >= 800) {
        return '四星'
      } else if(val >= 700) {
        return '三星'
      } else if(val >= 600) {
        return '二星'
      } else if(val >= 500) {
        return '一星'
      } else {
        return '未达标'
      }
    },
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  created() {
    this.$set(
      this.filterData,
      "stageApplyType",
      this.defaultSelectStringForSearch
    );
    this.setFilterData();
    this.changeQuery(true);
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  methods: {
    handleBack() {
      this.$router.go(-1);
    },

    // 预设方法
    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
        },
      });
      this.loadPageList();
    },

    // 设置参数
    setFilterData() {
      // key
      const { key, stageApplyType } = this.$route.query;
      key && this.$set(this.filterData, "key", key);
      stageApplyType &&
        this.$set(this.filterData, "stageApplyType", stageApplyType);
    },

    // 加载列表请求方法
    loadPageList(flag = false) {
      const paramsData = {
        groupUuid: this.groupUuid,
        stageUuid: this.stageUuid,
        page: this.page,
        size: this.pageSize,
        type: this.activeNav ? this.activeNav.toUpperCase() : "YOUTH",
        key: this.filterData.key,
        stageApplyType: this.filterData.stageApplyType,
      };
      if (!flag) this.loading = true;
      getOrgAuditPage(paramsData)
        .then((res) => {
          if (!flag) this.loading = false;
          if (res.code) {
            this.$msssage.error(res.msg);
            return;
          }
          const { content, empty, totalElements } = res;
          this.total = totalElements;
          this.empty = empty;
          this.pageList = content;
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },
    goInfoExpert (uuid) {
      this.$router.push({
        path: 'supervisoryExpert',
        query: {
          uuid
        }
      })
    },
    handleListAction(type, row) {
      if (type === "audit") {
      } else if (type === "find") {
      } else if (type === "unSubmit") {
        this.$message.warning("用户未提交！");
        return;
      }
      const { groupUuid, stageUuid, uuid: youthUuid, youthName, youthShortName, audit } = row;
      this.$router.push({
        path: "orgCheckDetails",
        query: {
          groupUuid,
          stageUuid,
          youthUuid,
          youthName,
          youthShortName,
          audit,
        },
      });
    },

    handleEditSort() {
      if (this.pageList.length) {
        this.isShowSortDialog = true;
      } else {
        this.$message.warning("没有可参与申报评估排名的单位");
      }
    },

    handleCallback(flag) {
      if (flag) {
        this.changeQuery(true);
      }
    },
    handleUpdatePageList() {
      this.changeQuery(true);
    },

    handleToggleRecommend(row) {
      const { uuid, organUuid, recommendUuid } = row;
      let postData = {
        stageUuid: this.stageUuid,
        youthUuid: uuid,
        organUuid,
      };
      if (recommendUuid) postData.uuid = recommendUuid;
      toggleOrgRecommend(postData)
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          this.loadPageList(true);
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.nav-btn-box
  display flex
  .btn
    margin-right 20px
    padding 10px 15px
    cursor pointer
    user-select none
    &.active
      background-color $green_color
</style>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        height 45px
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 45px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      /*height 100%*/
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        color $color_white
.seq
  width 5%
.youthName
  width 23%
  display flex
  flex-direction column
.submit
  width 7%
  text-align center
.updateTime
  width 11%
.score
  width 9%
  text-align center
.auditScore
  width 15%
  text-align center
.expertAuditScore
  width 13%
  text-align center
.youthScore
  width 10%
  text-align center
.auditSort
  width 18%
  text-align center
.orgAuditState
  width 10%
  text-align center
.action
  // width 16%
  flex 1
  .item
    cursor pointer
    user-select none
    &.active
      color $green_color
    &.danger
      color $red_color
  .split
    margin 0 5px
.ml10
  margin-left 10px
.suc
  color $green_color
</style>

<style lang="stylus" >
.y-input
  width 180px
  margin-right 20px
  input
    border-radius 0px !important
</style>
